/**
 * @generated SignedSource<<3f88fdf65aa65a1b274ed404490c6191>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type areaDesignerQuery$variables = Record<PropertyKey, never>;
export type areaDesignerQuery$data = {
  readonly printAreaTemplates: ReadonlyArray<{
    readonly height: number;
    readonly isDefault: boolean;
    readonly name: string;
    readonly templateID: number;
    readonly width: number;
  }>;
};
export type areaDesignerQuery = {
  response: areaDesignerQuery$data;
  variables: areaDesignerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "templateID",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDefault",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "areaDesignerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PrintAreaTemplate",
        "kind": "LinkedField",
        "name": "printAreaTemplates",
        "plural": true,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "areaDesignerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PrintAreaTemplate",
        "kind": "LinkedField",
        "name": "printAreaTemplates",
        "plural": true,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "837ea1180159803169f9298532b32c57",
    "id": null,
    "metadata": {},
    "name": "areaDesignerQuery",
    "operationKind": "query",
    "text": "query areaDesignerQuery {\n  printAreaTemplates {\n    templateID\n    isDefault\n    name\n    width\n    height\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3b8bc199767161755a17fa9d52f6777f";

export default node;
